//NEW STYPEPARAMS METHOD
var TEXT_BOX_SIZE_UNITS = {
    PERCENT: 'PERCENT',
    PIXEL: 'PIXEL',
};
export default TEXT_BOX_SIZE_UNITS;
//# sourceMappingURL=layoutParams_info_sizeUnits.js.map